"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.developments = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var DevelopmentsAction_1 = require("@/pages/developments/actions/DevelopmentsAction");
var Enquire_1 = require("@/pages/common/components/Enquire");
var MegaMenuSide_1 = require("../common/components/MegaMenuSide");
var MegaMenu_1 = require("../common/components/MegaMenu");
var DevelopmentPageAssetPurpose_1 = require("../development/states/model/DevelopmentPageAssetPurpose");
var Bigpopup_1 = require("../common/components/Bigpopup");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, imgDomain: state.layout.imgDomain })); };
var mapDispatchToProps = function (dispatch) { return ({
    changePage: function (page) { return dispatch(DevelopmentsAction_1.default.changePage(page)); },
}); };
exports.developments = function (props) {
    var getHero = function (developmentAssets, assetPurpose) {
        var photo = developmentAssets.filter(function (asset) { return (asset.categoryId === 999 && (asset.purposeFlag & assetPurpose) == assetPurpose); })
            .map(function (asset, index) { return ({
            urlSmall: "" + props.imgDomain + asset.fileLocation + "small/" + asset.resourceText + "." + asset.fileExtension,
            urlMedium: "" + props.imgDomain + asset.fileLocation + "medium/" + asset.resourceText + "." + asset.fileExtension,
            urlLarge: "" + props.imgDomain + asset.fileLocation + "large/" + asset.resourceText + "." + asset.fileExtension,
            name: asset.assetName,
            index: index
        }); })[0];
        return photo;
    };
    var cardClass = classnames_1.default(['c-developmentList__card']);
    var getDistrict = function (addresses) {
        if (addresses && addresses.length > 0 && addresses[0].localityName) {
            return addresses[0].localityName;
        }
        else {
            return '';
        }
    };
    var renderProjects = function (developmentProjects) {
        return developmentProjects.map(function (development, index) {
            var hero = getHero(development.developmentAssets, DevelopmentPageAssetPurpose_1.AssetPurpose.SubHeroInLandingPage);
            var district = getDistrict(development.addresses);
            return (React.createElement("a", { target: "_blank", key: index, href: "/" + props.lang + "/firsthand-development/" + development.developmentName.replace(' ', '-').toLowerCase() + "/" + development.developmentId, className: cardClass },
                React.createElement("div", { className: "c-developmentList__image" },
                    React.createElement("picture", { className: 'c-developments__picture' },
                        React.createElement("source", { srcSet: hero ? hero.urlSmall : '', media: "(max-width: 520px)" }),
                        React.createElement("source", { srcSet: hero ? hero.urlMedium : '', media: "(max-width: 768px)" }),
                        React.createElement("source", { srcSet: hero ? hero.urlLarge : '' }),
                        React.createElement("img", { className: "c-developmentList__img", src: hero ? hero.urlMedium : '', alt: development.developmentName, loading: "lazy" }))),
                React.createElement("div", { className: 'c-developmentList__bg' }),
                React.createElement("div", { className: "c-developmentList__info" },
                    React.createElement("div", { className: "c-developmentList__district" }, district),
                    React.createElement("div", { className: "c-developmentList__address" }, development.address),
                    React.createElement("div", { className: "c-developmentList__developer" }, development.developer)),
                React.createElement("div", { className: "c-developmentList__popup" },
                    React.createElement("div", { className: "c-developmentList__popup-body" },
                        React.createElement("div", { className: "c-developmentList__popup-cta" },
                            React.createElement("a", { target: "_blank", className: "c-developmentList__popup-btn", href: "/" + props.lang + "/firsthand-development/" + development.developmentName.replace(' ', '-').toLowerCase() + "/" + development.developmentId }, props.developments.t.cardPopupMore)))),
                React.createElement("div", { className: "c-developmentList__info-mobile" },
                    React.createElement("div", { className: "c-developmentList__info-mobile-district" }, district),
                    React.createElement("div", { className: "c-developmentList__info-mobile-address" }, development.address),
                    React.createElement("div", { className: "c-developmentList__info-mobile-developer" }, development.developer),
                    React.createElement("div", { className: "c-developmentList__info-mobile-cta" },
                        React.createElement("a", { target: "_blank", className: "c-developmentList__info-mobile-btn", href: "/" + props.lang + "/firsthand-development/" + development.developmentName.replace(' ', '-').toLowerCase() + "/" + development.developmentId }, props.developments.t.cardPopupMore)))));
        });
    };
    var renderBanner = function () {
        var assets = props.developments.projects.flatMap(function (project) { return project.developmentAssets; });
        var hero = getHero(assets, DevelopmentPageAssetPurpose_1.AssetPurpose.HeroInLandingPage);
        return (React.createElement("div", { className: "c-developments__banner" },
            React.createElement("div", { className: "c-developments__banner-bg c-developments__banner__overlay" },
                React.createElement("picture", { className: 'c-developments__picture' },
                    React.createElement("source", { srcSet: hero.urlSmall, media: "(max-width: 520px)" }),
                    React.createElement("source", { srcSet: hero.urlMedium, media: "(max-width: 768px)" }),
                    React.createElement("source", { srcSet: hero.urlLarge }),
                    React.createElement("img", { src: hero.urlMedium, alt: hero.name, loading: "lazy" }))),
            React.createElement("div", { className: "c-developments__banner__info" },
                React.createElement("div", { className: "c-developments__banner__title" }, props.developments.t.bannerTitle),
                React.createElement("div", { className: "c-developments__banner__caption" }, props.developments.t.bannerCaption))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MegaMenu_1.default, { nobottom: true }),
        React.createElement(MegaMenuSide_1.default, null),
        React.createElement("div", { className: 'c-developments' },
            renderBanner(),
            React.createElement("div", { className: "c-developmentList" },
                React.createElement("div", { className: "c-developmentList__cards" }, renderProjects(props.developments.projects)))),
        React.createElement(Enquire_1.default, null),
        React.createElement(Bigpopup_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.developments);
